import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ModuleLoader from '@/_components/loader/module/module.vue'

import { hasBklrModule } from '@/views/Project/Bklr/plugins/bklr'
import Authentication from '@/views/Authentication/models/authentication'
import VbitStatusBanner from '@/components/banner/vbitStatus.vue'

@Component({
    components: { AppToolbar, ModuleLoader, VbitStatusBanner },
})
export default class Bkrl extends Mixins<MixinInterface>() {
    loading = false
    get projectId() {
        return this.$route.params.type == 'p' ? this.$route.params.id : null
    }

    get project() {
        return this.projectId ? this.$store.getters.project(this.projectId) : null
    }

    get src() {
        return this.projectId
            ? `https://personnel.${process.env.VUE_APP_VBIT_API}/ui?project=${this.projectId}`
            : null
    }
}
